import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/api' : '/api' });

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = 'Bearer ' + token;
  return req;
});

export const register = (data) => API.post('/auth/register', data);
export const login    = (data) => API.post('/auth/login', data);

export const getMenus   = ()         => API.get('/menus');
export const createMenu = (data)     => API.post('/menus', data);
export const updateMenu = (id, data) => API.patch('/menus/' + id, data);
export const deleteMenu = (id)       => API.delete('/menus/' + id);

export const getCategories  = (menuId)   => API.get('/categories?menu_id=' + menuId);
export const createCategory = (data)     => API.post('/categories', data);
export const updateCategory = (id, data) => API.patch('/categories/' + id, data);
export const deleteCategory = (id)       => API.delete('/categories/' + id);

export const getItems   = (menuId)            => API.get('/items?menu_id=' + menuId);
export const createItem = (data)              => API.post('/items', data);
export const updateItem = (id, data)          => API.patch('/items/' + id, data);
export const toggleItem = (id, is_available)  => API.patch('/items/' + id + '/availability', { is_available });
export const deleteItem = (id)                => API.delete('/items/' + id);

export const getStaff    = ()     => API.get('/staff');
export const createStaff = (data) => API.post('/staff', data);
export const resetPin    = (id)   => API.patch('/staff/' + id + '/reset-pin');
export const revokeStaff = (id)   => API.patch('/staff/' + id + '/revoke');

export const getHours  = ()          => API.get('/opening-hours');
export const setHours  = (data)      => API.post('/opening-hours', data);
export const updateDay = (day, data) => API.patch('/opening-hours/' + day, data);

export const uploadImage = (formData) => API.post('/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

export default API;
